import React from "react";

export default function AnnouncementBar({
  message = "",
  enabled = true,
  height = 36,
  speedMs = 12000,
  style = {},
}) {
  if (!enabled || !message) return null;
  const text = ` ${message} `;

  return (
    <>
      <div
        id="announcement-bar"
        className="fixed top-0 left-0 right-0 z-[10000] border-b overflow-hidden text-center uppercase tracking-widest text-[11px] md:text-xs bg-white"
        style={{ height, lineHeight: `${height}px`, ...style }}
        aria-live="polite"
      >
        <div
          className="inline-block whitespace-nowrap will-change-transform"
          style={{ animation: `tbto-marquee ${speedMs}ms linear infinite` }}
        >
          <span className="px-8">{text.repeat(3)}</span>
        </div>
      </div>
      <style>{`
        @keyframes tbto-marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-33.333%); }
        }
        @media (prefers-reduced-motion: reduce) {
          #announcement-bar div { animation: none !important; transform: none !important; }
        }
      `}</style>
    </>
  );
}
